module.exports = __webpack_public_path__ + "img/collect_a.e8af0490.svg";